import React, { useState } from 'react'
import { useUser } from '@state/uses/users'
import { useHistory } from 'react-router-dom'
import api from '@services/api'
import { saveDance } from '@services/dances'
import SubmitButton from '@components/Buttons/SubmitButton'
import ConfirmModal from '@components/Modals/ConfirmModal'
import MessageModal from '@components/Modals/MessageModal'
import { optModalTexts } from '@components/AddEditDance/DanceSubmit'
import { SubmitBtnContainer } from '@appearance/styled'
import i18n from '@localization/i18n'
import urlUtils from '@services/urlUtils'
export const DANCE_STATUS_ORDERED = 'מוזמן'
export const DANCE_STATUS_APPROVED = 'מאושר'
export const DANCE_STATUS_EXISTS = 'קיים ריקוד'
const deleteDance = i18n.t('edit_dance.delete_dance')
const rejectDance = i18n.t('edit_dance.reject_dance')
const confirmDeleteDance = i18n.t('edit_dance.confirm_delete_dance')
const confirmRejectDance = i18n.t('edit_dance.confirm_reject_dance')
const checkAdminInCoChoreographers = (dance, user) => {
    let res = false
    if (dance?.co_choreographers?.length > 0) {
        dance.co_choreographers.map((choreographer) => {
            if (
                user?.user_id === choreographer?.id ||
                user?.first_name + user?.last_name ===
                    choreographer?.first_name + choreographer?.last_name
            ) {
                res = true
            }
        })
    }
    return res
}

const assets = (user) => ({
    [DANCE_STATUS_ORDERED]: {
        btnText: i18n.t('edit_dance.confirm_request'),
        deleteBtnText: user.is_admin ? rejectDance : deleteDance,
        confirmText: i18n.t('edit_dance.confirm_confirm_request'),
        deleteConfirmText: user.is_admin
            ? confirmRejectDance
            : confirmDeleteDance,
        nextStatus: DANCE_STATUS_APPROVED,
    },
    [DANCE_STATUS_APPROVED]: {
        btnText: i18n.t('edit_dance.make_dance_exist'),
        deleteBtnText: i18n.t('edit_dance.delete_dance'),
        confirmText: i18n.t('edit_dance.confirm_make_dance_exist'),
        deleteConfirmText: i18n.t('edit_dance.confirm_delete_dance'),
        nextStatus: DANCE_STATUS_EXISTS,
    },
    [DANCE_STATUS_EXISTS]: {
        deleteBtnText: i18n.t('edit_dance.delete_dance'),
        deleteConfirmText: i18n.t('edit_dance.confirm_delete_dance'),
    },
})

export default ({ dance, del, formValid }) => {
    const user = useUser()
    const history = useHistory()

    if (!user || !dance.id) {
        return null
    }

    if (user && !user.is_admin && !del) {
        return null
    }

    if (user && !user.is_admin && del && dance.status === DANCE_STATUS_EXISTS) {
        return null
    }

    const isReject = del && dance.status === DANCE_STATUS_ORDERED

    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showDoneModal, setShowDoneModal] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [reason, setReason] = useState(null)

    const asset = assets(user)[dance.status]

    const goToDancesScreen = () => {
        setShowDoneModal(false)
        urlUtils.redirectToPreviousUrl()
    }

    const onSubmit = () => {
        if (asset.nextStatus === DANCE_STATUS_EXISTS && !del) {
            if (dance.video_url || user.is_admin) {
                setShowConfirmModal(true)
            } else {
                setShowErrorModal(true)
            }
        } else {
            setShowConfirmModal(true)
        }
    }

    const saveChanges = () => {
        setShowConfirmModal(false)

        if (del) {
            api.deleteDance(dance.id, getReasonObj()).subscribe(
                (res) => {
                    setShowDoneModal(true)
                },
                (error) => {
                    console.log('rejectDance error', error)
                }
            )
        } else {
            const statusParams = Object.assign({}, getReasonObj(), {
                status: asset.nextStatus,
            })
            const newDance = Object.assign({}, dance, statusParams)
            saveDance(newDance, () => {
                setShowDoneModal(true)
                // goToDancesScreen()
            })
        }
    }

    const buttonText = asset[del ? 'deleteBtnText' : 'btnText']
    const confirmText = asset[del ? 'deleteConfirmText' : 'confirmText']
    const shouldDisableButton =
        buttonText === i18n.t('edit_dance.delete_dance')
            ? false
            : user?.is_admin &&
              dance?.choreographer.id == user?.user_id &&
              (buttonText === i18n.t('edit_dance.make_dance_exist') ||
                  buttonText === i18n.t('edit_dance.confirm_request'))
            ? true
            : checkAdminInCoChoreographers(dance, user)

    if (!buttonText) {
        return null
    }

    const getReasonObj = () => {
        if (!reason) {
            return {}
        }
        if (isReject) {
            return { reject_reason: reason }
        } else if (del) {
            return { delete_reason: reason }
        }
        return { approve_reason: reason }
    }

    const getReasonLabel = () => {
        if (isReject) {
            return i18n.t('edit_dance.reject_reason')
        } else if (del) {
            return i18n.t('edit_dance.delete_reason')
        } else {
            return i18n.t('edit_dance.confirm_reason')
        }
    }

    return (
        <SubmitBtnContainer>
            <SubmitButton
                onClick={onSubmit}
                label={buttonText}
                theme={del ? 'dark' : 'white'}
                disabled={(!del && !formValid) || shouldDisableButton}
            />
            <ConfirmModal
                isOpen={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                onConfirm={saveChanges}
                title={buttonText}
                mainText={confirmText}
                withTextInput={
                    user.user_id !== dance.choreographer.id &&
                    (del || dance.status === DANCE_STATUS_ORDERED)
                }
                textInputLabel={getReasonLabel()}
                textInputValue={reason || ''}
                onChangeTextInput={setReason}
                // textInputRequired={true}
            />
            <MessageModal
                isOpen={showDoneModal}
                title={optModalTexts.editDance.title}
                mainText={optModalTexts.editDance.mainText}
                onClose={goToDancesScreen}
            />
            <MessageModal
                isOpen={showErrorModal}
                title={i18n.t('modals.video_url_empty')}
                mainText={i18n.t('modals.video_url_empty_description')}
                onClose={() => setShowErrorModal(false)}
            />
        </SubmitBtnContainer>
    )
}
